import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ExternalLink } from "lucide-react";
import { resolveImage } from "../lib/api";

export default function DetailsModal({ product, open, onClose, onBuy }) {
    return (
        <AnimatePresence>
            {open && product && (
                <motion.div
                    data-testid="details-modal"
                    className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/80 backdrop-blur-sm"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        className="w-full sm:max-w-md bg-[#121212] rounded-t-3xl sm:rounded-3xl border-t sm:border border-white/10 p-6 flex flex-col relative max-h-[90vh] overflow-y-auto no-scrollbar"
                        initial={{ y: "100%", opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: "100%", opacity: 0 }}
                        transition={{ type: "spring", damping: 28, stiffness: 260 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            data-testid="modal-close-btn"
                            onClick={onClose}
                            aria-label="Close"
                            className="absolute top-4 right-4 p-2 bg-black/80 rounded-full text-white/80 hover:text-white hover:bg-[#FF5A00] transition-colors z-10"
                        >
                            <X size={20} />
                        </button>

                        <img
                            src={resolveImage(product.image_url)}
                            alt={product.title}
                            className="w-full h-64 object-cover rounded-2xl mb-6"
                            draggable={false}
                        />

                        <h2
                            data-testid="modal-title"
                            className="font-display text-3xl uppercase tracking-tight mb-1"
                        >
                            {product.title}
                        </h2>
                        {product.price && (
                            <div
                                data-testid="modal-price"
                                className="text-xl kw-orange font-bold mb-4"
                            >
                                {product.price}
                            </div>
                        )}
                        <p
                            data-testid="modal-description"
                            className="text-white/70 leading-relaxed mb-8 whitespace-pre-wrap"
                        >
                            {product.description || "No description provided."}
                        </p>

                        <button
                            data-testid="modal-buy-btn"
                            onClick={() => onBuy?.(product)}
                            className="w-full py-4 kw-orange-bg text-black font-black text-lg rounded-xl flex items-center justify-center gap-2 uppercase tracking-wider hover:scale-[1.01] transition-transform kw-glow"
                        >
                            Buy now <ExternalLink size={18} />
                        </button>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
